<div style="overflow-y: auto;" mdbModal #addEditProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 *ngIf="mode==='ADD'" class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
                <h4 *ngIf="mode==='EDIT'" class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="addEditProducto.hide()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">

                <!-- Nav Tabs -->
                <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-4  indigo'" [contentClass]="'pd-0'">

                    <!--Panel 1: Datos Personales-->
                    <mdb-tab heading="Datos del producto">
                        <app-productos-form-add-edit (onSuccess)="onSuccessSaveProducto($event)">
                        </app-productos-form-add-edit>
                    </mdb-tab>

                    <!--Panel 1: Datos Comerciales-->
                    <mdb-tab heading="Datos comerciales">
                        <app-productos-form-datos-comerciales (onSuccess)="onSucessSaveDatosComerciales()">
                        </app-productos-form-datos-comerciales>
                    </mdb-tab>

                    <!--Panel 1: Stock-->
                    <!-- <mdb-tab heading="Stock">
                        <app-form-stock>
                        </app-form-stock>
                    </mdb-tab> -->

                </mdb-tabset>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                    (click)="addEditProducto.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="submit" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect
                    (click)="guardarDatosProducto()" *ngIf="step===1">
                    Guardar datos producto
                </button>
                <button type="submit" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect
                    (click)="guardarDatosComerciales()" *ngIf="step===2">
                    Guardar datos comerciales
                </button>
            </div>
        </div>
    </div>
</div>

<app-modal-confirm>
</app-modal-confirm>